/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      const mm = gsap.matchMedia();

      mm.add( '(max-width: 1023px)', () => {
        $( '.case-study' ).each( function( key, val ) {
          const height = $( val ).height();

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              pin: '.case-study__link-bar-wrapper',
              start: 'top top',
              end: '+=' + ( height - window.innerHeight ),
              scrub: 0,
              // markers: true,
              onRefresh: ( self ) => {
                self.spacer.classList.add( 'pointer-events-none' );
              },
            },
          } );
        } );
      } );

      mm.add( '(min-width: 1024px)', () => {
        const xPx = $( '.case-study__inner' )[0].scrollWidth;
        const speed = 6000;

        gsap.to( '.case-study__inner', {
          x: ( ( xPx - window.innerWidth ) * -1 ),
          ease: 'none',
          scrollTrigger: {
            trigger: '.case-study',
            scrub: 1,
            start: 'top top',
            end: '+=' + speed,
            // markers: true,
          },
        } );

        gsap.to( '.case-study__inner', {
          scrollTrigger: {
            trigger: '.case-study',
            start: 'top top',
            pin: true,
            pinSpacing: true,
            scrub: 1,
            end: '+=' + ( speed + 500 ),
            // markers: true,
          },
        } );

        gsap.to( '.case-study__link-bar-wrapper', {
          x: ( ( xPx - window.innerWidth ) ),
          ease: 'none',
          scrollTrigger: {
            trigger: '.case-study__inner',
            scrub: 1,
            start: 'top top',
            end: '+=' + speed,
            // markers: true,
          },
        } );

        if ( $( '.case-study__squiggle' ).length ) {
          $( '.case-study__inner' ).each( function( key, val ) {
            const squiggle = $( '.case-study__squiggle' )[0];
            const squiggleOffset = $( '.case-study__squiggle' ).offset().left;
            // console.log( squiggleOffset );
            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                start: squiggleOffset + ' 50%',
                end: '+=500px',
                scrub: 0,
                // markers: true,
              },
            } );
            tl.fromTo( squiggle, {strokeDasharray: 1200, strokeDashoffset: 1200}, {strokeDashoffset: 0, ease: 'linear'}, 0 );
          } );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'case-study', COMPONENT );
} )( app );
